import {
    DatabaseOutlined,
    TeamOutlined,
    ShopOutlined,
    CreditCardOutlined,
    BookOutlined,
    ShoppingCartOutlined,
    DollarOutlined,
    TagOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";

export const adminMenuItems = [
    {
        key: "2",
        icon: <DatabaseOutlined />,
        label: "Maestros",
        children: [
            { key: "2.1", icon: <TeamOutlined />, label: <Link to="/clientes">Clientes</Link> },
            { key: "2.2", icon: <ShopOutlined />, label: <Link to="/productos">Productos</Link> },
            { key: "2.3", icon: <CreditCardOutlined />, label: <Link to="/formas-pago">Formas de Pago</Link> },
            { key: "2.4", icon: <BookOutlined />, label: <Link to="/colegios">Colegios</Link> },
            { key: "2.5", icon: <ShoppingCartOutlined />, label: <Link to="/tpvs">Tiendas</Link> },
            { key: "2.6", icon: <DollarOutlined />, label: <Link to="/precios-venta">Precios de Venta</Link> },
            { key: "2.7", icon: <TagOutlined />, label: <Link to="/cupones">Cupones Activos</Link> },
            { key: "2.8", icon: <TagOutlined />, label: <Link to="/campanas">Campañas</Link> },
        ]
    },
    {
        key: "6",
        icon: <UserOutlined />,
        label: <Link to="/usuarios">Usuarios</Link>,
    },
];
